import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";
import { ProviderTag } from "../types";
import { formatProviderTagError } from "../utils/formatProviderTagError";

export async function createProviderTag(spaceId: string, name: string): Promise<ProviderTag> {
  const trimmedName = name.trim();
  const { data, error } = await apiClient
    .from('provider_tags')
    .insert({
      space_id: spaceId,
      name: trimmedName,
    })
    .select()
    .single();

  if (error) {
    throw new Error(formatProviderTagError(error, 'Erreur lors de la création du tag.'));
  }

  return data;
}

export function useCreateProviderTag() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();
  const spaceId = currentSpace?.id ?? '';

  return useMutation({
    mutationFn: (name: string) => createProviderTag(spaceId, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.tags(spaceId) });
    },
  });
}

